import React, { useState, useEffect } from 'react'
import Api from '../../../pages/api/api'
import { Grid } from '@material-ui/core'
import styles from './antiviruses.module.css'
import Progress from '../../modules/progress/progress'
import NotFoundResult from '../not_found_result'
import { isMobile } from 'react-device-detect';

export default function Anitiviruses(props) {


    const [anitvirusData, setAntiVirusData] = useState()
    const [isLoading, setIsLoading] = useState(true)
    const [isNotFound, setIsNoutFound] = useState(false)

    useEffect(() => {
        Api.getAntiviruses({
            "hash": props.hash
        })
            .then(result => {
                setIsLoading(false)
                if (result.result) {
                    const rows = Object.entries(result.result).reduce(function (rows, key, index) {
                        return (index % 2 == 0 ? rows.push([key])
                            : rows[rows.length - 1].push(key)) && rows;
                    }, []);
                    setAntiVirusData(rows)
                } else {
                    setIsNoutFound(true)
                }

            })
            .catch(err => {
                setIsNoutFound(true)
                setIsLoading(false)
            })


    }, [])

    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    const mapHandler = (data, index) => {
        return (
            <div key={index}>
                <div>
                    <Grid container>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <div className={styles.right_side_container} style={(anitvirusData.length >= 2 || data[1] !== undefined) ? { borderLeft: "solid 1px rgba(151, 151, 151, 0.2)" } : null}>
                                <div className={styles.map_container} style={isMobile ? { backgroundColor: "rgba(17, 25, 42, 0.05)" } : index % 2 == 0 ? { backgroundColor: "rgba(17, 25, 42, 0.05)" } : { backgroundColor: "#ffffff" }}>
                                    <Grid container>
                                        <Grid item xs={6} sm={3} md={3} lg={3}>
                                            <div className={`${styles.anti_name_container} flex`}>
                                                <img className={styles.map_img} src={`/assets/icons/${data[0][0] !== undefined && data[0][0]}.png`} alt="Icon" />
                                                <span className={styles.anti_name}>{capitalizeFirstLetter(data[0][0])}</span>
                                            </div>
                                        </Grid>
                                        <Grid item xs={6} sm={9} md={9} lg={9}>
                                            <div className={`${styles.anti_result}`}>
                                                {data[0][1] ? <span className={`${styles.malware_container} englishIranSans`}>{data[0][1]}</span> : <img src='/assets/icons/checked.svg' alt="Icon" />}
                                            </div>
                                        </Grid>
                                    </Grid>
                                </div>
                            </div>
                        </Grid>
                        {
                            data[1] !== undefined &&
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <div className={styles.left_side_container}>
                                    <div className={styles.map_container} style={isMobile ? { backgroundColor: "#ffffff" } : index % 2 == 0 ? { backgroundColor: "rgba(17, 25, 42, 0.05)" } : { backgroundColor: "#ffffff" }}>
                                        {
                                            data[1] !== undefined && (
                                                <Grid container>
                                                    <Grid item xs={6} sm={3} md={3} lg={3}>
                                                        <div className={`${styles.anti_name_container} flex`}>
                                                            <img className={styles.map_img} src={`/assets/icons/${data[1][0] !== undefined && data[1][0]}.png`} alt="Icon" />
                                                            <span className={styles.anti_name}>{capitalizeFirstLetter(data[1][0])}</span>
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={6} sm={9} md={9} lg={9}>
                                                        <div className={`${styles.anti_result}`}>
                                                            {data[1][1] ? <span className={`${styles.malware_container} englishIranSans`}>{data[1][1]}</span> : <img src='/assets/icons/checked.svg' alt="Icon" />}
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            )
                                        }
                                    </div>
                                </div>
                            </Grid>
                        }
                    </Grid>
                </div>
            </div >
        )
    }

    if (isLoading) return (<Progress css={styles.vulns_progress} />)
    else if (isNotFound && !isLoading) return (<NotFoundResult />)
    else
        return (
            <div className={`${styles.container} shadow_white`}>
                {anitvirusData !== undefined && anitvirusData.map(mapHandler)}
            </div>
        )
}